<div class="main" style="flex: 1 1 auto; min-width: 0px;">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-tab-align="center">
        @for (link of links; track link) {
        <a [routerLink]="[link]" routerLinkActive="router-link-active" mat-tab-link (click)="activeLink = link"
            [active]="activeLink == link"> {{link | titlecase}} </a>
        }

    </nav>
    <mat-tab-nav-panel #tabPanel mat-tab-align="center">
        <div class="pt-20">
            <router-outlet>

            </router-outlet>
        </div>